import assign from 'lodash.assign';
export class IdentifierType {
    constructor(init) {
        assign(this, init);
    }
    value;
    schemeID;
    schemeName;
    schemeAgencyID;
    schemeAgencyName;
    schemeVersionID;
    schemeDataURI;
    schemeURI;
}
